import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const IframeWrapper = styled.div`
  width: ${props => props.width || '100vw'};
  height: ${props => props.height || '100%'};
  min-height: ${props => props.height || '100vh'};
  overflow: hidden;
`;

class Iframe extends React.Component {
  render() {
    const { src, width, height, minHeight } = this.props;
    return (
      <IframeWrapper width={width} height={height} minHeight={minHeight}>
        <iframe
          title={new Date().getTime()}
          frameBorder="0"
          width="100%"
          height="100%"
          src={src}
        />
      </IframeWrapper>
    );
  }
}

Iframe.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  src: PropTypes.string.isRequired
};

export default Iframe;



// WEBPACK FOOTER //
// ./src/components/Iframe/Iframe.js